export const credentialsResourceType = 'credentials';
